export const environment = {
  production: false,
  serverBaseUrl: 'https://taskr-test.axia.no/api',
  version: '2026.10.20-120',
  versionCheckIntervalInMinutes: 1,
  enableServiceWorker: true
};
